import { FacebookAuthProvider, getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup, TwitterAuthProvider, updateProfile } from 'firebase/auth';
import { fetchUserInfo, updateUserInfo, uploadImageDataUrl } from './firebase';
import { promisedUrlToImgDataUrl, userPicUploadUrl } from './utils';

const auth = getAuth();
export const fbProvider = new FacebookAuthProvider()
export const glProvider = new GoogleAuthProvider()
export const twProvider = new TwitterAuthProvider()
export const mcProvider = new OAuthProvider('microsoft.com')

export function signIn(provider) {
  provider.setCustomParameters({ 'display': 'popup' })

  return signInWithPopup(auth, provider)
    .then(async result => {
      localStorage.setItem('user.uid', result.user.uid)

      let credentialFromResult
      const isFB = provider.providerId === 'facebook.com'
      const isGL = provider.providerId === 'google.com'
      const isTW = provider.providerId === 'twitter.com'

      if (isFB) {
        credentialFromResult = FacebookAuthProvider.credentialFromResult
      } else if (isGL) {
        credentialFromResult = GoogleAuthProvider.credentialFromResult
      } else if (isTW) {
        credentialFromResult = TwitterAuthProvider.credentialFromResult
      } else {
        return
      }

      try {
        const { accessToken } = credentialFromResult(result)
        const userId = result.user.uid
        const photoURL = result.user.providerData[0].photoURL
        const downloadURL = photoURL + ((isFB) ? '?access_token=' + accessToken : '')

        const userInfo = await fetchUserInfo(userId)

        if (userInfo && userInfo.uploadedPic) {
          // Do nothing, user already uploaded a different pic
          return
        }

        // Download the social network photo
        // and upload to Firebase storage
        const dataUrl = await promisedUrlToImgDataUrl(downloadURL)
        const uploadedUrl = await uploadImageDataUrl(userPicUploadUrl(userId), dataUrl)
        const data = { photoURL: uploadedUrl }

        updateUserInfo(userId, data)

        return updateProfile(result.user, data)
      } catch (err) {
        return Promise.reject(err)
      }


    })
}

export function signOut() {
  auth.signOut().then(() => {
    localStorage.removeItem('user.uid')
  })
}

export function isSignedIn() {
  return auth.currentUser !== null
}
